<template>
  <FeatureFlagSwitcher :flag="Feature_Flags.PORTAL_LOYALTY_REVAMP">
    <template #new>
      <LoyaltyEnhanced />
    </template>
    <template #old>
      <Loyalty />
    </template>
  </FeatureFlagSwitcher>
</template>

<script>

import LoyaltyEnhanced from './V2/Loyalty.vue';
import Loyalty from './Loyalty.vue';
import { Feature_Flags } from '@/enums/globals';

export default {
  name: 'LoyaltyFlagSwitcher',
  components: {
    LoyaltyEnhanced,
    Loyalty,
  },
  data() {
    return { Feature_Flags };
  }
};
</script>
